import React, { ReactText } from 'react'
import { Box, Text, Layer, DataTable, Spinner } from "grommet";
import  useTableauRecord  from '../hooks/useTableauRecord'
import { TableauInfo } from '../config/types';
import TableauCellFormat from './TableauCellFormat';

const TableauUnit = (props:any) => {
    const [aTableau, setATableau] = React.useState<TableauInfo|null>(null)
    const [aBook, setABook] = React.useState<any>(null)
    const [Records, setRecords] = React.useState([])
    const [recordReady, setRecordReady] = React.useState(false)

    const [columnsKo, setColumnsKo] = React.useState([])
    const [tableRecords, setTableRecords] = React.useState<any[]>([]);
    const [tableColumns, setTableColumns] = React.useState<any[]>([]);

    const [sWidth, setSWidth] = React.useState('');
    const [sHeight, setSHeight] = React.useState('');

    React.useEffect(() => {

        let tableauInfo = props.tableauinfo
        let bookInfo = props.bookinfo
        console.log("tableau init", tableauInfo, bookInfo);

        if(tableauInfo){
            setABook(bookInfo)
            setATableau(tableauInfo);
            let columnsKo = tableauInfo.columns_ko.split(";");
            let columnsZh = tableauInfo.columns.split(";");
            let columns:any[] = [];
            let col_bold = ["學校名",  "道名"]
            let col_pin = ["學校名",  "道名"]
            let col_wide = ['學校名', '所在地']
            for(let i=0; i<columnsZh.length; i++){
                let col_zh = columnsZh[i]

                let primaryValue = false
                if(i<2) { primaryValue = true }

                let pinValue = false
                if (col_pin.includes(col_zh)) {
                  pinValue = true;
                }

                let colSizeValue = '60px'
                if (col_wide.includes(col_zh)) {
                  colSizeValue = "150px";
                } else if (
                  col_zh.includes("修業年限") ||
                  col_zh.includes("修業年限")
                ) {
                  colSizeValue = "50px";
                } else if (col_zh.includes("學級數")) {
                  colSizeValue = "70px";
                } else if (col_zh.includes("道名")) {
                  colSizeValue = "50px";
                } else if (col_zh.includes("創立年月")) {
                  colSizeValue = "80px";
                }

                let searchValue = false
                if (col_zh.includes("學校名") || col_zh.includes("所在地")) {
                  searchValue = true;
                }
                let col_header = []
                if (col_zh.includes("/")) {
                    col_header = col_zh.split("/");
                } else {
                    col_header = [col_zh];
                }

                let a_col = {
                  property: col_zh,
                  header: <Box direction='column'>
                        {col_header.map((v:any)=>(
                            <Box direction='column' key={v}>
                                <Text size='12px'>{v}</Text>
                            </Box>
                        ))}
                    </Box>,
                  primary: primaryValue,
                  pin: pinValue,
                  size: colSizeValue,
                  // search: searchValue,
                  render: (datum: any) =>
                    col_bold.includes(col_zh) ? (
                      <Box
                        style={{ minWidth: colSizeValue }}
                        pad={{ horizontal: "2px" }}
                      >
                        <Text size="13px" weight="bold">
                          {<TableauCellFormat cell={datum[col_zh]} />}
                        </Text>
                      </Box>
                    ) : (
                      <Box
                        style={{ minWidth: colSizeValue }}
                        pad={{ horizontal: "2px" }}
                      >
                        <Text size="13px">
                          {<TableauCellFormat cell={datum[col_zh]} />}
                        </Text>
                      </Box>
                    ),
                };
                columns.push(a_col)
            }
            setTableColumns(columns)
        }
        setSWidth((window.innerWidth * 0.9).toString() + "px");
        setSHeight((window.innerHeight * 0.9).toString() + "px");
    },[])

    React.useEffect(() => {
        if(aTableau){
            console.log("call tableau records")
            const receiveRecords = async() =>{
                const resRecords =
                  await useTableauRecord.getTableauRecordsByTableauId(
                    props.tableauinfo.tableau_id
                  );
                // console.log("TableauUnit-aTableau", aTableau, resRecords);
                if (resRecords.result) {
                  setRecords(resRecords.tableaurecords);
                }
            }
            receiveRecords()
        }
    },[aTableau])

    React.useEffect(()=>{

        if(!recordReady && Records.length > 0){
            console.log("call tableau records", Records)
            setRecordReady(true)
            let record_array_ko:any[] = []
            let record_array_zh:any[] = []
            Records.map((record:any) => {
                let a_line_ko = JSON.parse(record.record_text_ko);
                let a_line_zh = JSON.parse(record.record_text_zh);

                // check key is '학교명' or '소재지'in a_line_ko
                if (a_line_ko["학교명"] && a_line_zh["學校名"]) {
                    a_line_zh["學校名"] += "|" + a_line_ko["학교명"];
                    a_line_zh["學校名"]=a_line_zh["學校名"].replaceAll(';',', ');
                    // console.log(a_line_zh["學校名"]);
                }
                if (a_line_ko["소재지"]) {
                  a_line_zh["所在地"] += "|" + a_line_ko["소재지"];
                }
                record_array_ko.push(a_line_ko);
                record_array_zh.push(a_line_zh);
            })
            console.log(record_array_zh)
            setTableRecords(record_array_zh)
        }
    },[Records])

    return (
      <>
        {aTableau && (
          <Box
            width="sWidth"
            height="sHeight"
            align="start"
            justify="start"
            style={{ maxHeight: "95vh", maxWidth: "95vw" }}
            pad={{ top: "20px", horizontal: "20px" }}
          >
            <Box margin="10px" direction="column">
              <Text margin='5px'>
                <Text size="13px" color="grey">
                  {aBook.book_title}
                </Text>
                <Text size="12px" color="grey" margin={{left:'5px'}}>
                  {aBook.numeration.replace('(', ' (')}
                </Text>
              </Text>

              <Text size="20px" weight="bold">
                {aTableau.tableau_title}
              </Text>
            </Box>
            <Box
              align="start"
              justify="start"
              overflow="auto"
              style={{ maxHeight: "90vh" }}
              margin={{ top: "30px", bottom: "15px" }}
            >
              <DataTable
                fill
                step={10}
                show={20}
                background={{ pinned: "light-2" }}
                data={tableRecords}
                columns={tableColumns}
                pin
                size=""
                // onClickRow={() => {}}
                // paginate
                placeholder={
                  tableRecords.length === 0 && (
                    <Box
                      fill
                      align="center"
                      justify="center"
                      direction="row"
                      pad="large"
                      gap="small"
                      background={{
                        color: "background-front",
                        opacity: 0.1,
                      }}
                    >
                      <Spinner />
                      <Text weight="bold">Loading ...</Text>
                    </Box>
                  )
                }
              ></DataTable>
            </Box>
          </Box>
        )}
      </>
    );
}

export default TableauUnit;
